import constants from "@/api/constants";

export function translateConversationStatus(status: string, isFilter: boolean = false): string {
	if (status === null || status === undefined || status.trim().length == 0) return "";
	if (constants.areEqual(status, constants.CONVERSATION_STATUS.InProgress)) return "In Progress";
	if (constants.areEqual(status, constants.CONVERSATION_STATUS.ReadyForReview)) return "Ready for Review";
	if (constants.areEqual(status, constants.CONVERSATION_STATUS.Delivered)) return "Received";
	if (constants.areEqual(status, constants.CONVERSATION_STATUS.NotStarted)) return "Not Started";
	return status;
}

export function translateProjectStatus(status: string): string {
	if (status === null || status === undefined || status.trim().length == 0) return "";
	if (constants.areEqual(status, constants.PROJECT_STATUS.InProgress)) return "In Progress";
	if (constants.areEqual(status, constants.PROJECT_STATUS.Completed)) return "Completed";
	if (constants.areEqual(status, constants.PROJECT_STATUS.NotStarted)) return "Not Started";
	return status;
}
